import React, { useContext } from 'react';
import { injectIntl } from 'react-intl';
import Footer from '@uniiverse/library/components/footer';
import Navbar from '@uniiverse/library/components/navbar';
import LocaleContext from 'context/locale-context';
import AccountNavbar from '../../components/account-navbar';
import { LOCALES, localesNavBar } from '../../../src/lib/locale';
import { OrganizationContext } from '../../components/organization-select/withOrganization';
import { withFilters, FiltersContext } from '../../components/reports/withFilters';
import { locale } from './locale.js';
import AddOnsTable from '../../components/add-ons/table';
import styles from './styles-module.css';
import './index.css';
import { ORDERS_PAGE, ADD_ONS_PAGE } from './consts';

const AddOns = injectIntl(({intl, history}) => {
  const localeContext = useContext(LocaleContext);
  const { selectedMembership } = useContext(OrganizationContext);
  const { currencies } = useContext(FiltersContext);

  return (
    <>
      <Navbar
        user={localeContext.user}
        locales={localesNavBar}
        switchLocale={localeContext.switchLocale}
      />
      <AccountNavbar
        currentUser={localeContext.user}
        currencies={currencies}
      />
      <section className={styles.addOns}>
        <div className={styles.addOnsTitle}>{intl.formatMessage(locale.title)}</div>
        <div className={styles.addOnsDescription}>
          {intl.formatMessage(locale.description)}
        </div>
        <div className={styles.addOnsNavigation}>
          <a href={ADD_ONS_PAGE} className={styles.active}>{intl.formatMessage(locale.title)}</a>
          <a href={ORDERS_PAGE}>{intl.formatMessage(locale.orders)}</a>
        </div>
        <AddOnsTable
          intl={intl}
          hostId={selectedMembership.owner.id}
          hasPermissionForManageAddOns={selectedMembership.manage_add_ons}
          history={history}
        />
      </section>
      <Footer
        switchLocale={localeContext.switchLocale}
        locale={localeContext.locale}
        locales={LOCALES}
      />
    </>
  );
});

export default withFilters(AddOns);
